
import { createSlice } from '@reduxjs/toolkit';
import { fetcherPost, fetcherGet, fetcherPut } from "../utils/fetcher";
import { setLoader } from './commonSlice';
import { APIS, isEmpty } from '../utils/constants';
import { checkNextPage } from '../utils/logger';
import { getUserCredit } from "./studentSlice";

const initialState = {
    mentorList: {},
    docTypes: {},
    dueDateList: {},
    documentList: {},
    documentDetails: {},
    openPopup: false,
    openPopupReport: false,
    isUserCredit: {},
    statusList: {}
}

const documentSlice = createSlice({
    name: 'document',
    initialState,
    reducers: {
        setMentorList: (state, action) => {
            state.mentorList = action.payload
        },
        setDocTypes: (state, action) => {
            state.docTypes = action.payload
        },
        setDueDateList: (state, action) => {
            state.dueDateList = action.payload
        },
        setDocumentList: (state, action) => {
            state.documentList = action.payload
        },
        setDocumentDetails: (state, action) => {
            state.documentDetails = action.payload
        },
        setOpenPopup(state, action) {
            state.openPopup = action.payload;
        },
        setOpenPopupReport(state, action) {
            state.openPopupReport = action.payload;
        },
        setUserCredit(state, action) {
            state.isUserCredit = action.payload;
        },
        setStatuses(state, action){
            state.statusList = action.payload
        }
    }
});

export function postStudentDocuments(payload, callback) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.POST_STUDENT_DOCUMENT, payload)
            .then((res) => {
                dispatch(setOpenPopup(true));
                dispatch(setLoader(false));
                dispatch(getDocumentList());
                if(callback){
                    callback(res)
                }
            })
            .catch((err) => {
                if(callback){
                    callback(err)
                }
                dispatch(setLoader(false));
            });
    };
}

export function saveStudentDocuments(payload, callback) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.SAVE_STUDENT_DOCUMENT, payload)
            .then((res) => {
                dispatch(setLoader(false));
                if(callback){
                    callback(res)
                }
            })
            .catch((err) => {
                if(callback){
                    callback(err)
                }
                dispatch(setLoader(false));
            });
    };
}

export function putStudentDocuments(payload) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPut(APIS?.PUT_STUDENT_DOCUMENT, payload)
            .then(() => {
                dispatch(setOpenPopup(true));
                dispatch(getDocumentDetails(payload?.document_id));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function getMentorList(page = 1, prev = [], searchQuery, is24HrMentor=false, is72HrMentor=false ) {
    return (dispatch) => {
        // dispatch(setLoader(true));
        let url = `${APIS.GET_MENTOR_LIST}${page}`;
        if (is24HrMentor==true) {
            url = url + `&is24HrMentor=${is24HrMentor}`;
        }
        if (is72HrMentor==true) {
            url = url + `&is72HrMentor=${is72HrMentor}`;
        }
        if (searchQuery?.length) {
            url = url + `&search=${searchQuery}`
        }
        fetcherGet(url)
            .then((response) => {
                const mentors = !isEmpty(response?.data) ? response?.data : {};
                const res = checkNextPage(mentors.pagination)
                mentors.pagination = res;
                mentors.result = [...prev, ...mentors.mentorData];
                dispatch(setMentorList(mentors));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function validateMentorAvailability(mentorId, userId, is24HrMentor = false, is72HrMentor = false, callback) {
    return (dispatch) => {
        dispatch(setLoader(true)); // Start loading

        let url = `${APIS.VALIDATE_MENTOR_AVAILABILITY}?mentorId=${mentorId}&user_id=${userId}`;
        
        // Append is24HrMentor to the URL if true
        if (is24HrMentor) {
            url += `&is24HrMentor=${is24HrMentor}`;
        }
        
        // Append is72HrMentor to the URL if true
        if (is72HrMentor) {
            url += `&is72HrMentor=${is72HrMentor}`;
        }
        fetcherGet(url)
            .then((res) => {
                dispatch(setLoader(false));
                if(callback){
                    callback(res)
                }
            })
            .catch((err) => {
                if(callback){
                    callback(err)
                }
                dispatch(setLoader(false));
            });
    }
}


export function getDocumentList(page = 1, limit=10) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(`${APIS?.GET_DOCUMENT_LIST}${page} + &limit=${limit}`)
            .then((response) => {
                const documentList = !isEmpty(response?.data) ? response?.data : []
                dispatch(setDocumentList(documentList));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                dispatch(setLoader(false));
                console.error(err);
            });
    };
}

export function getDocumentDetails(docId) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(`${APIS?.GET_DOCUMENT_DETAILS}${docId}`)
            .then((response) => {
                const documentDetails = !isEmpty(response?.data) ? response?.data : []
                dispatch(setDocumentDetails(documentDetails));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                dispatch(setLoader(false));
                console.error(err);
            });
    };
}

export function getDocTypes(page = 1) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(`${APIS?.GET_DOC_TYPE}${page}`)
            .then((response) => {
                const allDocType = !isEmpty(response?.data) ? response?.data : []
                dispatch(setDocTypes(allDocType));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                dispatch(setLoader(false));
                console.error(err);
            });
    };
}

export function getDueDateList(page = 1) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(`${APIS?.GET_DUE_DATE}${page}`)
            .then((response) => {
                const dueDateList = !isEmpty(response?.data) ? response?.data : []
                dispatch(setDueDateList(dueDateList));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                dispatch(setLoader(false));
                console.error(err);
            });
    };
}

export function checkUserCredit(docType, checkCredit) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(`${APIS?.USER_CHECK_CREDIT}${docType}`)
            .then((response) => {
                dispatch(setUserCredit(response.data));
                if (checkCredit && typeof checkCredit === 'function') {
                    checkCredit(response.data);
                }
                dispatch(setLoader(false));
            })
            .catch(() => {
                if (checkCredit && typeof checkCredit === 'function') {
                    checkCredit(false);
                }
                dispatch(setLoader(false));
            });
    };
}

export function userRequestCredit(payload) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.USER_REQUIRE_CREDIT, payload)
            .then(() => {
                dispatch(getUserCredit())
                dispatch(setOpenPopup(false));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    }
}
export function postDocEditRejection(payload) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.DOC_EDIT_REJECTION, payload)
            .then(() => {
                dispatch(setOpenPopupReport(true));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    }
}
export function getStatusList(type) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(`${APIS?.GET_ALL_STATUSES}?type=${type}`)
            .then((response) => {
                const statusList = !isEmpty(response?.data) ? response?.data : []
                dispatch(setStatuses(statusList));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                dispatch(setLoader(false));
                console.error(err);
            });
    };
}

export function approveDenyDocAction(payload) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.APPROVE_DENY_DOC, payload)
            .then(() => {
                dispatch(setOpenPopup({ isOpen: true, data: payload }));
                dispatch(getDocumentDetails(payload?.document_id))
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    }
}

export const {
    setMentorList,
    setDocumentList,
    setDocTypes,
    setDueDateList,
    setDocumentDetails,
    setOpenPopup,
    setOpenPopupReport,
    setUserCredit,
    setStatuses
} = documentSlice.actions;
export default documentSlice.reducer;